"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.lib = exports.flushPortals = exports.createPortal = exports.DEFAULT_PORTAL_ID = void 0;
var utils_1 = require("@lglp/utils");
var react_dom_1 = __importDefault(require("react-dom"));
var portals = [];
exports.DEFAULT_PORTAL_ID = '#portal-container';
var createPortal = function (children, selector) {
    if (selector === void 0) { selector = exports.DEFAULT_PORTAL_ID; }
    if (!utils_1.canUseDOM()) {
        portals.push({ selector: selector, children: children });
        return null;
    }
    return react_dom_1["default"].createPortal(children, document.querySelector(selector) || document.body);
};
exports.createPortal = createPortal;
var flushPortals = function () {
    var copy = __spreadArray([], portals);
    portals.length = 0;
    return copy;
};
exports.flushPortals = flushPortals;
exports.lib = {};
//# sourceMappingURL=common.js.map